<app-feedback-message
  iconType="lock-open"
  title="You have successfully"
  subtitle="logged in"
  [textLines]="[
    'The service is online so users can check their login credentials.',
    'The first weekly reporting begins July 22, 2025.'
  ]"
></app-feedback-message>
